import axios from "axios";
import { baseURL } from "../config/api";

export const getReservationSummaryByPaymentRequestUniqeid = (uniqeid: string, tenantId: string) => {
    return getFetch(`paymentRequest/GetPaymentRequestByUniqid?uniqeid=${uniqeid}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}